import { Link } from 'react-router-dom';

export function Support() {
  return (
    <article className="mx-auto max-w-screen-md px-6 py-10 text-text-primary">
      <Link to="/" className="text-xs text-text-muted underline">← Home</Link>
      <h1 className="mt-4 text-2xl font-medium">Support</h1>
      <p className="mt-3 text-sm text-text-muted">
        Bug reports, feedback, and feature requests are welcome. Email <a className="underline" href="mailto:hi@nudgeapp.example">hi@nudgeapp.example</a>.
      </p>
      <p className="mt-3 text-sm text-text-muted">
        On iOS, push notifications require the app to be added to your Home Screen. The Settings page has a walkthrough.
      </p>
    </article>
  );
}
